<template>
    <div class="file">
        <el-col :span="6">
            <div style="margin-top:20%;margin-left:15%" >
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    action="http://127.0.0.1:7777/files/saveFileList"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :on-change="handleChange"
                    :file-list="fileList"
                    :auto-upload="false">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                    <div slot="tip" class="el-upload__tip">文件大小不能超过10M</div>
                </el-upload>
            </div>
        </el-col>
        <el-col :span="18">
            <div style="margin-top:2%;margin-left:5%;margin-right:5% ">
            <el-card shadow="always">
                    <el-table
                        :max-height="tableHeight"
                        :data="allFiles.filter(data => !tableSearch || data.name.toLowerCase().includes(tableSearch.toLowerCase()) ||data.id.toLowerCase().includes(tableSearch.toLowerCase()) )"
                        style="width: 100%">
                        <el-table-column
                        label="序号"
                        type="index"
                        width="auto"
                        min-width="10%">
                        </el-table-column>
                        <el-table-column
                        label="文件 ID"
                        prop="id"
                        width="auto"
                        min-width="10%">
                        </el-table-column>
                        <el-table-column
                        label="文件名称"
                        width="auto"
                        min-width="30%"
                        prop="name">
                        </el-table-column>
                        <el-table-column
                        label="文件分类"
                        width="auto"
                        sortable
                        min-width="30%"
                        prop="type">
                          <!-- <template slot="header" slot-scope="scope">
                            <el-select v-model="serch"  size="mini" style="width:150px" placeholder="选择文件分类进行搜索">
                              <el-option
                                v-for="item in types"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                              </el-option>
                            </el-select>
                          </template> -->
                        </el-table-column>
                        <el-table-column   width="auto" min-width="30%">
                          <template slot="header" slot-scope="scope">
                              <el-input
                              v-model="tableSearch"
                              size="mini"
                              placeholder="输入关键字搜索"/>
                          </template>
                          <template slot-scope="scope">
                              <el-button size="mini" type="primary"  @click="beforeUpdateType(scope.row)">修改分类</el-button>
                              <el-button size="mini" type="primary"  @click="handleSee(scope.$index, scope.row)">查看</el-button>
                              <el-button size="mini" type="danger" @click="beforeDelete(scope.$index, scope.row)">删除</el-button>
                          </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </div>
        </el-col>
        <el-dialog
          title="修改文件分类"
          :visible.sync="selectTypeVisible"
          width="30%">
          <span>{{seletedFile.name}}</span>
          <div   style="margin-top:7%">
            <el-select v-model="updateTypeId"  placeholder="请选择">
              <el-option
                v-for="item in types"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="selectTypeVisible = false">取 消</el-button>
            <el-button type="primary" @click="updateTypeById">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'File',
  data () {
    return {
      fileList: [],
      allFiles: [],
      tableSearch: '',
      tableHeight: window.innerHeight * 0.8,
      types: [],
      selectTypeVisible: false,
      seletedFile: '',
      updateTypeId: ''
    }
  },
  mounted () {
    this.getAllFiles()
    this.getFileType()
  },
  methods: {
    updateTypeById () {
      this.$axios({
        method: 'get',
        url: Common.baseUrl + 'files/updateFileType',
        params: {fileId: this.seletedFile.id, typeId: this.updateTypeId}
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          // console.log(res.data.data)
          this.getAllFiles()
          this.selectTypeVisible = false
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    getFileType () {
      this.$axios({
        method: 'get',
        url: Common.baseUrl + 'fileType/allType'
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          // console.log(res.data.data)
          this.types = res.data.data
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    beforeUpdateType (file) {
      this.selectTypeVisible = true
      this.seletedFile = file
    },
    getAllFiles () {
      this.$axios.get(Common.baseUrl + 'files/getAllFiles'
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          console.log(res.data.data)
          this.allFiles = res.data.data
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    submitUpload () {
      if (this.fileList.length <= 0) {
        this.$message({message: '请选择需要上传的文件！', type: 'warning'})
        return
      }
      for (let i in this.fileList) {
        if (this.fileList[i].size / 1024 / 1024 > 10) {
          this.$message.error(this.fileList[i].name + '        文件大小超过10M，' + '上传文件大小不能超过 10MB!')
          return
        }
      }
      let formData = new FormData()
      this.fileList.forEach(
        (val, index) => {
          formData.append('fileList', val.raw)
        }
      )
      this.$axios({
        method: 'post',
        url: Common.baseUrl + 'files/saveFileList',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '文件上传成功！',
            type: 'success'
          })
          this.fileList = []
          this.getAllFiles()
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handleRemove (file) {
      for (let i in this.fileList) {
        if (this.fileList[i].uid === file.uid) {
          this.fileList.splice(i, 1)
          i--
        }
      }
    },
    beforeRemove (file) {
      console.log(file)
      return this.$confirm('确定移除' + file.name + '?')
    },
    handleBeforeUpload (file) {
      console.log('123')
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
    },
    beforeSubmitUpload () {
      this.submitUpload()
    //   if (file.size / 1024 / 1024 > 10) {
    //     this.$message.error('上传图片大小不能超过 10MB!')
    //   }
    },
    handleChange (file, fileList) {
      this.fileList = fileList
    },
    deleteFile (file) {
      this.$axios.get(Common.baseUrl + 'files/deleteById', {params: {id: file.id}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          console.log(res.data.data)
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
          this.getAllFiles()
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    beforeDelete (index, file) {
      this.$confirm('是否删除文件  ' + file.name, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteFile(file)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSee (index, file) {
      window.open(file.url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/File.vue